export const PIPELINE_STEP_IDS = ['lin', 'adie', 'ics', 'de'] as const;

export type PipelineStepId = (typeof PIPELINE_STEP_IDS)[number];

export type PipelineRunMode = 'continuous' | 'step-by-step';

export type StepStatus = 'idle' | 'ready' | 'running' | 'completed' | 'error';

export type ParsedJsonUpload = {
  id: string;
  fileName: string;
  records: unknown[];
};

export type PipelineStreamProgress = {
  index: number;
  total: number;
  logId?: string;
};

export type PipelineStreamItem = {
  index: number;
  total: number;
  logId?: string;
  partIndex?: number;
  partTotal?: number;
  output: unknown;
  error?: string;
  receivedAt: number;
};

export type PipelineStreamMode = 'live' | 'summary';

export type PipelineStepState = {
  status: StepStatus;
  input: unknown;
  output: unknown;
  error: string | null;
  streamTotal?: number;
  streamProgress?: PipelineStreamProgress | null;
  streamItems?: PipelineStreamItem[];
  streamMode?: PipelineStreamMode;
};

export type PipelineDebugState = {
  runMode: PipelineRunMode;
  activeStepIndex: number;
  uploads: ParsedJsonUpload[];
  steps: Record<PipelineStepId, PipelineStepState>;
};

export type StepExample = {
  input: unknown;
  output: unknown;
};

export type StepDefinition = {
  id: PipelineStepId;
  engineKey: string;
  protoRef: string;
};
